const MasGender = "masculino";
const FemGender = "femenino";

const toBoolean = (value: string | any) => {
  switch (value?.toLocaleLowerCase()) {
    case 1:
    case "1":
    case "true":
    case true:
      return true;
      break;

    default:
      return false;
      break;
  }
};

const getRandomColor = () => {
  const color = Math.floor(Math.random() * 16777215).toString(16);
  return `#${color}`;
};

const getTableSizeBaseOnRef = (ref: any) => {
  return ref?.current?.searchContext?.state?.data?.length ?? 0;
};

const resetPageBaseOnRef = (ref: any) => {
  if (ref?.current?.paginationContext) {
    ref.current.paginationContext.currPage = 1;
  }
};

const getGenderIcon = (gender: string) => {
  if (gender?.toLocaleLowerCase()?.includes(MasGender)) {
    return `fas fa-mars`;
  } else if (gender?.toLocaleLowerCase()?.includes(FemGender)) {
    return `fas fa-venus`;
  } else {
    return `fas fa-genderless`;
  }
};

const notEmptyArray = <TValue>(
  value: TValue | null | undefined
): value is TValue => {
  return value !== null && value !== undefined;
};

const distinct = (value: any, index: any, self: any) => {
  return self.indexOf(value) == index
}

export {
  toBoolean,
  getRandomColor,
  getTableSizeBaseOnRef,
  resetPageBaseOnRef,
  getGenderIcon,
  notEmptyArray,
  distinct
};
